<template>
  <div id="tTtabBar">
    <TabBarItem type="mine" path="/toutiaomine">
      <template #selectedImg>
        <img src="~assets/img/toutiaoApp/ttMineSelected.png" style="width:33px;height:40px"/>
      </template>
      <template #unselectedImg>
        <img src="~assets/img/toutiaoApp/ttMineUnSelected.png" style="width:33px;height:40px"/>
      </template>
    </TabBarItem>
    <TabBarItem type="rebate" path="/toutiaorebate">
      <template #selectedImg>
        <img src="~assets/img/toutiaoApp/ttRebateSelected.png" style="width:45px;height:59px"/>
      </template>
      <template #unselectedImg>
        <img src="~assets/img/toutiaoApp/ttRebateUnSelected.png" style="width:45px;height:59px"/>
      </template>
    </TabBarItem>
  </div>
</template>

<script>
  import TabBarItem from "./TabBarItem.vue"
  export default {
    data () {
      return {

      }
    },
    components: {
      TabBarItem
    },
    methods:{
      close(){
        this.sendToClient('close?')
      }
    }
 }
</script>

<style>
/* div {
  background-color: bisque;
}
router-view{
  background-color: red;
} */

  #tTtabBar{
    background-color: #FFF3F3;
    flex-direction: column;
    width: 15vw;
	  height: 100%;	
  }
 
 
</style>


// WEBPACK FOOTER //
// src/views/TouTiaoApp/TabBar.vue